import { render } from "./ClientComplaint.vue?vue&type=template&id=5b2a41ee"
import script from "./ClientComplaint.vue?vue&type=script&lang=js"
export * from "./ClientComplaint.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__